import React, { FC } from 'react';

import { Typography } from '@mui/material';

import { useTextStyles } from '../../utils/styles';
import { IKImage } from '../IKImage';
import { useSliderCardStyles } from './styles';

interface SliderCardProps {
  imageUrl?: string | null;
  labelText?: string | null;
}

export const SliderCard: FC<SliderCardProps> = ({ imageUrl, labelText }) => {
  const classes = useSliderCardStyles();
  const textClasses = useTextStyles();

  return (
    <div className={classes.wrapper}>
      <IKImage path={imageUrl} className={classes.img} />
      {labelText && <div className={classes.label}>
        <Typography className={textClasses.metaLabel}>{labelText}</Typography>
      </div>}
    </div>
  );
};
